import ReactGA from 'react-ga4';

let isGAInitialized = false;

// Initialize Google Analytics
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (measurementId) {
    ReactGA.initialize(measurementId);
    isGAInitialized = true;

    window.gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    });

    console.log('Google Analytics initialized with ID:', measurementId);
  } else {
    console.warn(
      'Google Analytics measurement ID not found. Set REACT_APP_GA_MEASUREMENT_ID environment variable.'
    );
  }
};

// Check if GA is initialized before tracking
const safeTrack = (trackingFunction) => {
  if (isGAInitialized) {
    trackingFunction();
  } else {
    console.log('GA not initialized - tracking skipped');
  }
};

// Track page views
export const trackPageView = (path) => {
  safeTrack(() => ReactGA.send({ hitType: 'pageview', page: path }));
};

// Track custom events
export const trackEvent = (category, action, label = null, value = null) => {
  safeTrack(() => ReactGA.event({
    category,
    action,
    label,
    value,
  }));
};

// Track specific app events
export const trackAppEvent = {
  // File operations
  fileUpload: (fileCount) =>
    trackEvent('File', 'Upload', `Files: ${fileCount}`),

  // Graph operations
  graphGenerate: (preset) =>
    trackEvent('Graph', 'Generate', preset || 'Custom'),
  graphInspect: (methodName) => trackEvent('Graph', 'Inspect', methodName),

  // Demo interactions
  demoPresetSelect: (presetName) =>
    trackEvent('Demo', 'PresetSelect', presetName),
  githubLinkClick: () => trackEvent('Demo', 'GithubLinkClick'),
  proPlanWaitlistClick: () => trackEvent('Demo', 'ProPlanWaitlistClick'),
  claimAccessClick: () => trackEvent('Demo', 'ClaimAccessClick'),
  authorLinkClick: () => trackEvent('Demo', 'AuthorLinkClick'),

  // Error tracking
  error: (errorType, errorMessage) =>
    trackEvent('Error', errorType, errorMessage),

  // Sign-up tracking
  signUp: (type, country) => trackEvent('SignUp', type, country),

  // Feedback tracking
  feedbackRatingChange: (rating) => trackEvent(`FeedbackRatingChange:${rating}`),
  feedbackSubmit: (rating, comment) =>
    trackEvent('Feedback', 'Submit', rating, comment ? 1 : 0),
};
